/* G-String bow Parts page, Joey's approved design (sections/gs-bow-parts-callouts.liquid).
   The part forms are priced, finish-checked and added to the cart by assets/gstring.js (gs-buy-card contract); this
   file does the rest:
   - step 1, the bow number: checked like the shop's numbers (1285, JC067, W012), filled in from the address when
     coming from a bow's page, and nothing goes in the cart until it's in. It fills the bow boxes on every order
     ("Bow Model", "Number Under Grip"…, "Bow") and the private build-sheet key _spec (g-rex-1285).
   - tapping a part name opens its choices and outlines the part on the picture with a leader line and a label (no fill,
     no zoom, the picture never changes color); small parts outline the part they go in. On a computer, pointing at
     a name previews it. On a phone the bow lies on its side in a slim picture pinned at the top (turned sideways,
     there's no room to pin it, so it stays in its place above the list).
   - choices start on "Choose a color" (Add to cart asks for one); Raw and patterns turn the Finish off and leave it off
     the order (the shop's list, snippets/gs-nofinish.liquid); a color dot shows the picked color where we know it.
   - the address keeps the bow number and the open part (?number=1285&part=g-rex-cams). */
(() => {
  const root = document.querySelector('[data-gspc]');
  if (!root) return;
  const $ = (s, r = root) => r.querySelector(s);
  const $$ = (s, r = root) => Array.from(r.querySelectorAll(s));
  const NS = 'http://www.w3.org/2000/svg';
  const BOW = root.dataset.bow || '';
  const PREFIX = root.dataset.specPrefix || '';
  const reduced = () => matchMedia('(prefers-reduced-motion: reduce)').matches;
  const oneCol = () => matchMedia('(max-width: 899px)').matches;
  // one column with the picture pinned over the list (not on a phone turned sideways: there it stays in its place, see the CSS)
  const pinnedAbove = () => oneCol() && !!plate && getComputedStyle(plate).position === 'sticky';
  const mapEl = $('[data-gspc-map]');
  const MAP = mapEl ? JSON.parse(mapEl.textContent) : null;
  const rows = $$('[data-gspc-row]');
  const byHandle = Object.fromEntries(rows.map(r => [r.dataset.handle, r]));
  const handleize = v => String(v || '').toLowerCase().replace(/['’]/g, '').replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  const icon = {
    lock: '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true" focusable="false"><rect x="4" y="9" width="12" height="8" rx="1.5"/><path d="M7 9V6.5a3 3 0 0 1 6 0V9"/></svg>',
    check: '<svg width="16" height="16" viewBox="0 0 20 20" fill="none" stroke="currentColor" stroke-width="2.2" aria-hidden="true" focusable="false"><path d="m4 10.5 4 4 8-9"/></svg>',
  };
  const text = (el, s) => { el.textContent = s; return el; };

  /* ---------- step 1: the bow number ---------- */
  const numCard = $('[data-gspc-num]');
  const numBox = $('[data-gspc-number]');
  const numNote = $('[data-gspc-number-note]');
  const bowChip = $('[data-gspc-bowno]');
  const noteStart = numNote ? numNote.innerHTML : '';
  const GATE_MSG = 'Type your bow number at the top first (it\'s under the grip), so we make it to fit your bow.';
  // the shop's numbers: 1285, or letters then digits like JC067 and W012 (leading zeros only matter after letters)
  function bowNumber() {
    const raw = (numBox?.value || '').trim().replace(/^#/, '').replace(/\s+/g, '').toUpperCase();
    if (/^[0-9]{1,6}$/.test(raw)) return String(parseInt(raw, 10));
    return /^(JC|W)[0-9]{1,6}$/.test(raw) ? raw : '';
  }
  function refreshNumber() {
    const n = bowNumber();
    const typed = (numBox?.value || '').trim();
    numCard?.classList.toggle('is-ok', !!n);
    numCard?.classList.toggle('is-bad', !!typed && !n);
    if (numNote) {
      if (n) { numNote.innerHTML = icon.check + '<span></span>'; text(numNote.lastChild, 'Got it: parts will be made for ' + BOW + ' #' + n + '.'); }
      else if (typed) numNote.textContent = 'That doesn\'t look like a bow number. It\'s under the grip, like 1285 or JC067.';
      else numNote.innerHTML = icon.lock + '<span>' + noteStart + '</span>';
    }
    if (bowChip) {
      bowChip.classList.toggle('is-ok', !!n);
      bowChip.innerHTML = n ? icon.check + '<span></span>' : '';
      if (n) text(bowChip.lastChild, 'Bow #' + n); else bowChip.textContent = 'No bow # yet';
      bowChip.setAttribute('aria-label', n ? 'Bow number ' + n + ', change it' : 'No bow number yet, enter it');
    }
    // the bow details on every order (the product's own boxes) and the private build-sheet key
    $$('[data-gs-autofill]').forEach(inp => {
      inp.value = inp.dataset.gsAutofill.split(',').map(k => (k === 'bow_number' ? n : k === 'bow' ? BOW + (n ? ' #' + n : '') : '')).filter(Boolean).join(' · ');
    });
    $$('[data-gs-spec]:not([data-gs-spec-fixed])').forEach(inp => { inp.value = n && PREFIX ? PREFIX + '-' + n.toLowerCase() : ''; }); // a one-key timing cable keeps its key
    lookupBow(n);
    // the listing's own page gets the number and the bow's key, like the cards here (the bowstring's brand pick opens on
    // this bow and looks it up)
    $$('[data-gspc-details]').forEach(a => {
      const u = new URL(a.getAttribute('href'), location.origin);
      if (n) u.searchParams.set('number', n); else u.searchParams.delete('number');
      if (n && PREFIX) u.searchParams.set('spec', PREFIX + '-' + n.toLowerCase()); else u.searchParams.delete('spec');
      a.setAttribute('href', u.pathname + u.search);
    });
    // Add to cart waits for the number (and a "type your number first" note goes once it's in)
    if (n) $$('[data-gs-buy-msg]').forEach(m => { if (m.textContent === GATE_MSG || m.textContent.startsWith('Bow number first')) m.textContent = ''; });
    rows.forEach(row => {
      const add = $('.gs-buy-add', row);
      const locked = $('[data-gspc-locked]', row);
      const fit = $('[data-gspc-fit]', row);
      if (!add || !locked) return;
      if (row.hasAttribute('data-gspc-nonum')) { // the same timing cable on every bow of the model: no number needed
        add.hidden = false; locked.hidden = true; fit.className = 'gspc-fit is-ok';
        fit.innerHTML = icon.check + '<span></span>'; text(fit.lastChild, 'Fits every ' + BOW + ': they all take the same timing cable.');
        return;
      }
      add.hidden = !n;
      locked.hidden = !!n;
      if (!locked.firstElementChild) locked.insertAdjacentHTML('afterbegin', icon.lock);
      fit.className = 'gspc-fit' + (n ? ' is-ok' : '');
      if (n) { fit.innerHTML = icon.check + '<span></span>'; text(fit.lastChild, 'Made to fit ' + BOW + ' #' + n + '.'); }
      else fit.innerHTML = '<span>Type your bow number at the top first.</span><button type="button" data-gspc-goto>Go to bow number</button>';
    });
  }
  // the bow's record (public): its string length goes on string orders, so the build sheet shows the length to build to
  // (Joey, Oct 18 2026). Not on file: no length is sent and the shop looks it up.
  const bowInfo = {};
  let lookupSeq = 0;
  async function lookupBow(n) {
    const seq = ++lookupSeq;
    const setLen = v => $$('[data-gspc-strlen]').forEach(inp => { inp.value = v; });
    setLen('');
    if (!n || !PREFIX) return;
    const key = PREFIX + '-' + n.toLowerCase();
    if (!(key in bowInfo)) {
      try {
        const res = await fetch('/pages/bow/' + encodeURIComponent(key) + '?section_id=gs-bow-json', { signal: AbortSignal.timeout(8000) });
        const m = res.ok && (await res.text()).match(/<script type="application\/json" data-gs-bow-json>([\s\S]*?)<\/script>/);
        bowInfo[key] = m ? JSON.parse(m[1]) : { found: false };
      } catch (e) { return; } // a network hiccup: try again on the next change
    }
    if (seq !== lookupSeq) return; // the number changed meanwhile
    const b = bowInfo[key];
    if (b.found && b.string_length) {
      setLen(String(b.string_length).replace(/[″"]+$/, '') + '″');
      if (numNote) text(numNote.lastChild, 'Got it: parts will be made for ' + BOW + ' #' + n + '. On file: ' + String(b.string_length).replace(/[″"]+$/, '') + '″ string.');
    }
  }
  function gotoNumber() {
    if (!numCard) return;
    numCard.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block: 'center' });
    numBox.focus({ preventScroll: true });
    numCard.classList.remove('is-flash'); void numCard.offsetWidth; numCard.classList.add('is-flash');
  }
  numBox?.addEventListener('input', () => { refreshNumber(); syncUrl(); });
  bowChip?.addEventListener('click', gotoNumber);

  // "You may also need" quick adds are plain parts too: like a part's own row, the order says which bow it's for
  // (the shared snippets/gs-also-item.liquid has no bow box; refreshNumber fills this one)
  $$('.gspc-also [data-gs-buy][data-role="part"] [data-gs-buy-form]').forEach(f => {
    if (f.querySelector('[name="properties[Bow]"]')) return;
    const i = document.createElement('input');
    Object.assign(i, { type: 'hidden', name: 'properties[Bow]', value: '' });
    i.dataset.gsAutofill = 'bow';
    f.prepend(i);
  });

  /* ---------- choices: placeholders, color dots, Finish ---------- */
  const isPlaceholder = sel => !!sel.selectedOptions[0]?.hasAttribute('data-gspc-placeholder');
  const isRaw = v => { const h = handleize(v); return h === 'raw' || h.startsWith('raw-') || h.includes('no-paint'); };
  function refreshRow(row) {
    const form = $('[data-gs-buy-form]', row);
    if (!form) return;
    $$('select', form).forEach(sel => {
      sel.classList.toggle('is-empty', isPlaceholder(sel) || !sel.value);
      const chip = sel.closest('.gspc-field')?.querySelector('[data-gspc-chip]');
      if (!chip) return;
      const o = isPlaceholder(sel) ? null : sel.selectedOptions[0];
      const hex = o?.dataset.hex;
      const sw = o?.dataset.sw;
      chip.hidden = !(hex || sw);
      chip.style.background = sw ? 'center / cover url("' + sw + '")' : hex || 'transparent';
    });
    // Raw (no paint) and patterns take no finish: the Finish choice turns off and isn't sent (Joey, Oct 17 + Oct 18).
    // gstring.js does the same from the shop's list; this runs after it, and a color not picked yet counts as none.
    const box = $('[data-gs-finish]', form);
    if (!box) return;
    const note = $('[data-gspc-finnote]', form);
    const nofin = new Set((box.dataset.gsNofin || '').split('|').filter(Boolean));
    const picks = $$('[data-gs-option] select', form).filter(s => !isPlaceholder(s)).map(s => s.value);
    const raw = picks.find(v => isRaw(v));
    const pattern = picks.find(v => nofin.has(handleize(v)) && !isRaw(v));
    if ('gsAutoSolid' in box.dataset) { // power limbs: the finish follows the paint
      const v = pattern ? box.dataset.gsAutoPattern : box.dataset.gsAutoSolid;
      $$('input', box).forEach(i => { i.value = v; i.disabled = !!raw; });
      const t = $('[data-gs-auto-text]', box); if (t) t.textContent = v;
      box.hidden = !!raw;
      if (note) { note.hidden = !raw; note.innerHTML = '<b>Finish: none.</b> Raw limbs are left unpainted.'; }
      return;
    }
    const none = !!(raw || pattern);
    // a color that IS an anodize ("Clear anodize": Joey, Oct 25 2026, "clear is anodize only") locks the Finish to Anodize
    const ano = picks.some(v => /(^|-)anodize$/.test(handleize(v)));
    box.hidden = none;
    $$('select', box).forEach(s => {
      s.disabled = none;
      const a = [...s.options].find(o => /^anodize/i.test(o.value));
      if (!a) return;
      [...s.options].forEach(o => { if (o.value) o.disabled = ano && !none && o !== a; });
      if (ano && !none) s.value = a.value;
    });
    if (note) {
      note.hidden = !none;
      note.innerHTML = raw ? '<b>No finish to pick.</b> Raw means no paint, so there\'s no finish.' : '<b>No finish to pick.</b> Patterns have no finish choice.';
    }
  }
  root.addEventListener('change', e => {
    const row = e.target.closest('[data-gspc-row]');
    if (!row) return;
    if (e.target.classList.contains('is-missing')) {
      e.target.classList.remove('is-missing');
      const msg = $('[data-gs-buy-msg]', row);
      if (msg && !$('.is-missing', row) && /first/.test(msg.textContent)) msg.textContent = '';
    }
    refreshRow(row);
  });

  /* ---------- nothing goes in the cart without the bow number and a pick for every choice ---------- */
  root.addEventListener('submit', e => {
    const card = e.target.closest('[data-gs-buy]');
    if (!card) return;
    const msg = card.querySelector('[data-gs-buy-msg]');
    const stop = m => { e.preventDefault(); e.stopPropagation(); if (msg) msg.textContent = m; };
    if (!bowNumber() && !card.closest('[data-gspc-nonum]')) { stop(card.closest('.gspc-also') ? 'Bow number first (top of the page).' : GATE_MSG); gotoNumber(); return; }
    const form = e.target;
    const missing = $$('select', form).filter(s => !s.disabled && (isPlaceholder(s) || (s.required && !s.value)));
    if (!missing.length) return; // gstring.js checks the rest (custom lengths…) and adds it
    missing.forEach(s => s.classList.add('is-missing'));
    const first = missing[0];
    const label = first.closest('.gspc-field')?.querySelector('.gs-buy-label')?.textContent.trim() || 'this';
    stop((first.hasAttribute('data-gspc-color') ? 'Choose a color first' : 'Make a pick for "' + label + '" first') + (missing.length > 1 ? ' (' + missing.length + ' choices left).' : '.'));
    first.focus();
  }, true);
  root.addEventListener('click', e => {
    if (e.target.closest('[data-gspc-goto], [data-gspc-locked]')) { gotoNumber(); }
  });

  /* ---------- tapping a name: open its choices and mark it on the bow ---------- */
  let open = null;
  function setOpen(row, { scroll = true } = {}) {
    if (open === row) row = null; // tap again to close
    open = row;
    rows.forEach(r => {
      const on = r === row;
      r.classList.toggle('is-open', on);
      $('[data-gspc-open]', r).setAttribute('aria-expanded', String(on));
      $('[data-gspc-panel]', r).hidden = !on;
    });
    draw(row, true);
    syncUrl();
    if (row && scroll) {
      const r = row.getBoundingClientRect();
      const top = pinnedAbove() ? plate.getBoundingClientRect().bottom + 12 : headerBottom() + 12;
      // a computer scrolls only as far as needed, so the pinned picture stays in view near the end of the list
      const block = pinnedAbove() || r.top < top ? 'start' : 'nearest';
      if (r.top < top || r.bottom > innerHeight - 20) row.scrollIntoView({ behavior: reduced() ? 'auto' : 'smooth', block });
    }
  }
  root.addEventListener('click', e => {
    const btn = e.target.closest('[data-gspc-open]');
    if (btn) setOpen(btn.closest('[data-gspc-row]'));
  });
  // on a computer, pointing at a name previews it on the bow
  const list = $('.gspc-list');
  if (list && matchMedia('(hover: hover) and (pointer: fine)').matches) {
    list.addEventListener('mouseover', e => {
      const btn = e.target.closest('[data-gspc-open]');
      const want = btn ? btn.closest('[data-gspc-row]') : open;
      if (want !== shown) draw(want, false);
    });
    list.addEventListener('mouseleave', () => { if (shown !== open) draw(open, false); });
  }

  /* ---------- drawing: outline + leader line + label ---------- */
  const plate = $('[data-gspc-plate]');
  const stage = $('[data-gspc-stage]');
  const svg = $('[data-gspc-svg]');
  const bowG = $('[data-gspc-bowg]');
  const hlG = $('[data-gspc-hl]');
  const leadG = $('[data-gspc-lead]');
  const labs = $('[data-gspc-labs]');
  const bar = $('[data-gspc-bar]');
  const foot = $('[data-gspc-foot]');
  const footA = $('[data-gspc-foot-a]');
  const footB = $('[data-gspc-foot-b]');
  const shownNote = footA ? footA.textContent : '';
  const colorNote = footB ? footB.textContent : '';
  const ringId = svg ? svg.querySelector('filter[id^="gspc-ring"]')?.id : '';
  const hostId = svg ? svg.querySelector('filter[id^="gspc-host"]')?.id : '';
  let shown = null;
  let G = null;
  const el = (tag, attrs, parent) => { const n = document.createElementNS(NS, tag); for (const k in attrs) n.setAttribute(k, attrs[k]); parent.appendChild(n); return n; };
  function headerBottom() {
    const h = document.querySelector('#header-component');
    const b = h ? h.getBoundingClientRect().bottom : 0;
    return b > 0 ? b : 0;
  }
  // load the outlines early so the first tap draws at once
  if (MAP) Object.values(MAP.masks).forEach(m => { const i = new Image(); i.src = m[0]; });

  // fit the bow in the stage: standing up beside the list, lying on its side when the picture sits above the list
  function geometry() {
    const BOX = MAP.box;
    const W = stage.clientWidth;
    const H = stage.clientHeight;
    const bw = BOX[2] - BOX[0];
    const bh = BOX[3] - BOX[1];
    const g = { W, H, horiz: oneCol() };
    if (!g.horiz) {
      const k = Math.min((H - 40) / bh, (W - 24) / bw);
      const ox = (W - bw * k) / 2;
      const oy = (H - bh * k) / 2;
      Object.assign(g, { k, T: (x, y) => [ox + (x - BOX[0]) * k, oy + (y - BOX[1]) * k], m: [k, 0, 0, k, ox - BOX[0] * k, oy - BOX[1] * k], cross: [ox, ox + bw * k], small: W < 420 });
    } else {
      // the label room above and below the bow comes from the CSS (--gspc-room), the same number that sets the
      // stage height there, so the bow keeps its full width and only the room around it changes
      const room = parseFloat(getComputedStyle(stage).getPropertyValue('--gspc-room')) || 72;
      const k = Math.min((W - 16) / bh, (H - room) / bw);
      const ox = (W - bh * k) / 2;
      const oy = (H - bw * k) / 2;
      Object.assign(g, { k, T: (x, y) => [ox + (y - BOX[1]) * k, oy + (BOX[2] - x) * k], m: [0, -k, k, 0, ox - BOX[1] * k, oy + BOX[2] * k], cross: [oy, oy + bw * k], small: true });
    }
    // outline sizes in screen pixels, turned into picture pixels for the filters
    const px = g.small ? { gap: 1.1, ring: 3, edge: 3.8, thin: 2.5, soft: 0.4 } : { gap: 1.6, ring: 4.4, edge: 5.6, thin: 3.4, soft: 0.5 };
    g.ringMid = (px.gap + px.ring) / 2;
    $$('[data-r]', svg).forEach(f => {
      const v = px[f.dataset.r] / g.k;
      if (f.tagName === 'feGaussianBlur') f.setAttribute('stdDeviation', v.toFixed(2)); else f.setAttribute('radius', v.toFixed(2));
    });
    $$('[data-shadow]', svg).forEach(f => {
      const [d, s] = f.dataset.shadow.split(',').map(Number);
      f.setAttribute('dx', g.horiz ? (-d / g.k).toFixed(2) : 0);
      f.setAttribute('dy', g.horiz ? 0 : (d / g.k).toFixed(2));
      f.setAttribute('stdDeviation', (s / g.k).toFixed(2));
    });
    svg.setAttribute('viewBox', '0 0 ' + W + ' ' + H);
    bowG.setAttribute('transform', 'matrix(' + g.m.map(v => v.toFixed(4)).join(' ') + ')');
    return g;
  }
  function capsule(x1, y1, x2, y2, r) {
    const L = Math.hypot(x2 - x1, y2 - y1) || 1;
    const nx = -(y2 - y1) / L * r;
    const ny = (x2 - x1) / L * r;
    return 'M' + (x1 + nx) + ' ' + (y1 + ny) + 'L' + (x2 + nx) + ' ' + (y2 + ny) + 'A' + r + ' ' + r + ' 0 0 0 ' + (x2 - nx) + ' ' + (y2 - ny) +
      'L' + (x1 - nx) + ' ' + (y1 - ny) + 'A' + r + ' ' + r + ' 0 0 0 ' + (x1 + nx) + ' ' + (y1 + ny) + 'Z';
  }
  function setFoot(a, b, note) {
    if (!foot) return;
    footA.textContent = a;
    footB.textContent = b || '';
    foot.classList.toggle('is-note', !!note);
  }
  function setBar(name, hint) {
    if (!bar) return;
    bar.textContent = BOW + ' · ';
    bar.appendChild(text(document.createElement('strong'), name));
    bar.classList.toggle('is-hint', !!hint);
  }

  function draw(row, anim) {
    shown = row;
    if (!MAP || !stage) return;
    if (!G) G = geometry();
    hlG.replaceChildren(); leadG.replaceChildren(); labs.replaceChildren();
    stage.classList.toggle('is-anim', !!anim && !reduced());
    const def = row ? MAP.spots[row.dataset.spot] : null;
    // a part is marked: on a phone the caption under the bow steps aside for its label (see the CSS)
    plate?.classList.toggle('is-marked', !!def);
    if (!row) {
      setBar(oneCol() ? 'Tap a name below ↓' : 'Tap a part name →', true);
      setFoot(shownNote, oneCol() ? '' : colorNote);
      return;
    }
    const name = row.dataset.name;
    setBar(name, false);
    if (!def) { // not on the picture: say so under the picture, never over the bow (on a phone the bar names it)
      setFoot(oneCol() ? 'Not shown on this picture' : name + ' isn\'t shown on this picture', '', true);
      return;
    }
    setFoot(shownNote, oneCol() ? '' : colorNote);
    const host = row.hasAttribute('data-host');

    // the outline: the part's own silhouette (or the string's line), run through the outline filter
    const fg = el('g', { filter: 'url(#' + (host ? hostId : ringId) + ')' }, hlG);
    if (def.masks) {
      const lg = el('g', { transform: 'matrix(' + MAP.layer.join(' ') + ')' }, fg);
      def.masks.forEach(k => { const m = MAP.masks[k]; el('image', { href: m[0], x: m[1], y: m[2], width: m[3], height: m[4] }, lg); });
    } else if (def.line) {
      el('path', { d: capsule(...def.line), fill: '#000' }, fg);
    }

    // leader + label. u = along the bow, v = across it. Standing bow: string side ('l') is left; lying bow: string side is at the bottom.
    const g = G;
    const V = !g.horiz;
    const out = V ? (def.side === 'l' ? -1 : 1) : (def.side === 'l' ? 1 : -1);
    const anchors = def.at.map(a => {
      const s = g.T(a[0], a[1]);
      const d = g.ringMid * (def.side === 'l' ? -1 : 1); // step out onto the outline, away from the part
      return V ? [s[0] + d, s[1]] : [s[0], s[1] - d];
    });
    const uOf = pt => (V ? pt[1] : pt[0]);
    const vOf = pt => (V ? pt[0] : pt[1]);
    const P = (u, v) => (V ? [v, u] : [u, v]);
    const gapS = g.small ? 8 : 12;
    const gapL = g.small ? 6 : 8;
    const spine = out > 0 ? g.cross[1] + gapS : g.cross[0] - gapS;
    const vMax = V ? g.W : g.H;
    const uMax = V ? g.H : g.W;

    const lab = document.createElement('div');
    lab.className = 'gspc-lab ' + (V ? 'gspc-lab--' + def.side : 'gspc-lab--h' + (out > 0 ? ' gspc-lab--below' : ''));
    lab.textContent = row.dataset.call || name;
    if (row.dataset.tag) lab.appendChild(text(document.createElement('small'), row.dataset.tag));
    labs.appendChild(lab);
    let u = anchors.reduce((s, a) => s + uOf(a), 0) / anchors.length;
    let labEdge;
    if (V) {
      const col = out < 0 ? [8, spine - gapL] : [spine + gapL, vMax - 8];
      lab.style.left = col[0] + 'px';
      lab.style.width = (col[1] - col[0]) + 'px';
      const h = lab.offsetHeight;
      u = Math.min(Math.max(u, 6 + h / 2), uMax - 6 - h / 2);
      lab.style.top = (u - h / 2) + 'px';
      labEdge = out < 0 ? col[1] : col[0];
    } else {
      // one line over or under the lying bow (a second line would run into it): a long label on a narrow phone
      // steps its type down a little rather than spill past its box
      lab.style.maxWidth = (g.W - 12) + 'px';
      let fs = parseFloat(getComputedStyle(lab).fontSize);
      while (lab.scrollWidth > lab.clientWidth + 1 && fs > 10) { fs -= 0.5; lab.style.fontSize = fs + 'px'; }
      const w = lab.offsetWidth;
      const h = lab.offsetHeight;
      const left = Math.min(Math.max(u - w / 2, 6), uMax - 6 - w);
      lab.style.left = left + 'px';
      const top = out > 0 ? spine + gapL : spine - gapL - h;
      lab.style.top = Math.min(Math.max(top, 4), g.H - 4 - h) + 'px';
      labEdge = out > 0 ? spine + gapL : spine - gapL;
      if (u < left + 10 || u > left + w - 10) u = left + w / 2;
    }
    const us = anchors.map(uOf).concat(u);
    const f = n => n.toFixed(1);
    const pt = (uu, vv) => { const q = P(uu, vv); return f(q[0]) + ' ' + f(q[1]); };
    let d = 'M' + pt(u, labEdge) + 'L' + pt(u, spine);
    if (Math.max(...us) - Math.min(...us) > 0.5) d += 'M' + pt(Math.min(...us), spine) + 'L' + pt(Math.max(...us), spine);
    anchors.forEach(a => { d += 'M' + pt(uOf(a), spine) + 'L' + pt(uOf(a), vOf(a)); });
    el('path', { d, class: 'gspc-lead-halo', pathLength: 100 }, leadG);
    el('path', { d, class: 'gspc-lead', pathLength: 100 }, leadG);
    anchors.forEach(a => {
      el('circle', { cx: a[0], cy: a[1], r: g.small ? 5.5 : 7, class: 'gspc-dot-halo' }, leadG);
      el('circle', { cx: a[0], cy: a[1], r: g.small ? 3.4 : 4.4, class: 'gspc-dot' }, leadG);
    });
  }

  /* ---------- keep the picture right when the window changes ---------- */
  function sizes() {
    if (plate) document.documentElement.style.setProperty('--gspc-plate-h', Math.round(plate.getBoundingClientRect().height) + 'px');
  }
  if (stage && MAP && 'ResizeObserver' in window) new ResizeObserver(() => { sizes(); G = geometry(); draw(open, false); }).observe(stage);

  /* ---------- the address keeps the bow number and the open part, so a link can be shared ---------- */
  function syncUrl() {
    try {
      const u = new URL(location.href);
      const n = bowNumber() || (numBox?.value || '').trim();
      if (n) u.searchParams.set('number', n); else u.searchParams.delete('number');
      if (open) u.searchParams.set('part', open.dataset.handle); else u.searchParams.delete('part');
      history.replaceState(history.state, '', u);
    } catch (e) { /* the address just won't follow along */ }
  }

  /* ---------- start ---------- */
  const q = new URLSearchParams(location.search);
  if (numBox && q.get('number')) numBox.value = q.get('number').slice(0, 12);
  rows.forEach(refreshRow);
  refreshNumber();
  if (MAP && stage) { sizes(); G = geometry(); }
  const want = byHandle[q.get('part')];
  if (want) {
    setOpen(want, { scroll: false });
    const go = () => want.scrollIntoView({ block: 'start' });
    requestAnimationFrame(go);
    if (document.readyState !== 'complete') window.addEventListener('load', go, { once: true }); // after the picture and fonts settle
  } else draw(null);
  // the browser can put choices back (back button): match the page to them
  window.addEventListener('pageshow', e => { if (e.persisted) { rows.forEach(refreshRow); refreshNumber(); } });
})();
